import React from 'react';

const RefundPage = () => {
  return (
    <div className="refund-page">
      <div className="container">
        <div className="content-wrapper">
          <h1>Refund Policy</h1>
          
          <div className="content">
            <p><strong>Effective Date:</strong> January 2025</p>
            
            <p>This refund policy outlines how you can cancel or seek a refund for boba tea drinks and services that you have purchased through our Platform (www.bunny-boba.com). Please note that our products are freshly prepared beverages made to order according to your specific preferences.</p>

            <h2>Cancellation Policy</h2>
            
            <h3>1. Before Preparation</h3>
            <p>Cancellations will only be considered if the request is made <strong>before we start preparing your drink</strong>. Once our team begins preparing your customized boba tea, the order cannot be cancelled as the ingredients are already in use and the preparation process has begun.</p>

            <h3>2. After Preparation Starts</h3>
            <p>Once the drink preparation has begun, we <strong>cannot accept cancellation requests</strong> as our boba teas are made fresh to order with your specific customizations including:</p>
            <ul>
              <li>Flavor selections</li>
              <li>Toppings (pearls, jellies, etc.)</li>
              <li>Sweetness level preferences</li>
              <li>Ice level customizations</li>
              <li>Special dietary requirements</li>
            </ul>

            <h3>3. Ready for Pickup/Delivery</h3>
            <p>Orders that are ready for pickup or out for delivery <strong>cannot be cancelled</strong> as the preparation is complete and resources have been utilized.</p>

            <h2>Refund Policy</h2>

            <h3>1. No Refunds for Prepared Drinks</h3>
            <p>As our boba teas are <strong>freshly prepared beverages</strong> made according to your specific preferences and customizations, we <strong>do not offer refunds for completed orders</strong>. This policy is in place because:</p>
            <ul>
              <li>Each drink is individually crafted based on your order</li>
              <li>Fresh ingredients are used specifically for your order</li>
              <li>Customizations are made according to your preferences</li>
              <li>Food safety regulations prevent resale of prepared beverages</li>
            </ul>

            <h3>2. Quality Issues</h3>
            <p>If you receive a drink that is significantly different from what you ordered or if there are genuine quality issues, please contact our customer service immediately. We will work to resolve the issue by:</p>
            <ul>
              <li>Remaking your drink when possible</li>
              <li>Providing store credit for future orders</li>
              <li>Investigating the preparation process to prevent future issues</li>
            </ul>

            <p><strong>Quality issues include:</strong></p>
            <ul>
              <li>Wrong flavor or base tea</li>
              <li>Missing toppings that were ordered and paid for</li>
              <li>Incorrect sweetness or ice level significantly different from requested</li>
              <li>Contamination or foreign objects in the drink</li>
            </ul>

            <h3>3. Incorrect Orders Due to Our Error</h3>
            <p>In case you receive an incorrect order due to our preparation or fulfillment error, please report it to our customer service team <strong>within 15 minutes of receiving the product</strong>. We will:</p>
            <ul>
              <li>Remake your correct order at no additional charge</li>
              <li>Provide the corrected order as quickly as possible</li>
              <li>Ensure quality control measures are reviewed</li>
            </ul>

            <h3>4. Damaged or Spilled Products</h3>
            <p>If your drink is damaged, spilled, or compromised due to our packaging or delivery error, please report it immediately with photo evidence. We will provide:</p>
            <ul>
              <li>A replacement drink</li>
              <li>Store credit equivalent to your order value</li>
              <li>Investigation of packaging and delivery procedures</li>
            </ul>

            <h2>What We Do NOT Refund</h2>

            <h3>1. Taste Preferences</h3>
            <p>Refunds or exchanges are <strong>not available</strong> for drinks that you simply don't like due to personal taste preferences. We encourage customers to:</p>
            <ul>
              <li>Try smaller sizes first if unsure about a flavor</li>
              <li>Ask our staff for recommendations</li>
              <li>Review our flavor descriptions before ordering</li>
            </ul>

            <h3>2. Customization Choices</h3>
            <p>Customization choices (sweetness level, ice level, toppings) are <strong>final once the order is placed</strong> and preparation begins. Please review your order carefully before confirming.</p>

            <h3>3. Change of Mind</h3>
            <p>We cannot provide refunds for orders where customers have simply changed their mind after the preparation process has begun.</p>

            <h2>Refund Processing</h2>

            <h3>Approved Refunds</h3>
            <p>In the rare cases where refunds are approved (such as for system errors, double charges, or significant service failures), refunds will be:</p>
            <ul>
              <li>Processed back to your original payment method</li>
              <li>Completed within 3-7 business days</li>
              <li>Accompanied by email confirmation</li>
            </ul>

            <h3>Store Credit Alternative</h3>
            <p>In many cases, we may offer store credit as an alternative to cash refunds, which can be:</p>
            <ul>
              <li>Used for future orders</li>
              <li>Applied immediately to your account</li>
              <li>Valid for 12 months from issue date</li>
            </ul>

            <h2>How to Report Issues</h2>

            <h3>Immediate Contact</h3>
            <p>For any concerns regarding your order, please contact our customer service team <strong>immediately</strong> through:</p>
            <ul>
              <li>In-store: Speak with our staff directly</li>
              <li>Phone: During business hours</li>
              <li>Website: Use our contact form</li>
              <li>Email: Through our official channels</li>
            </ul>

            <h3>Required Information</h3>
            <p>When reporting an issue, please provide:</p>
            <ul>
              <li>Order number or receipt</li>
              <li>Date and time of order</li>
              <li>Description of the issue</li>
              <li>Photos if applicable (for damaged/incorrect items)</li>
              <li>Your contact information</li>
            </ul>

            <h2>Special Circumstances</h2>

            <h3>System Errors</h3>
            <p>In case of payment system errors, duplicate charges, or technical issues during ordering, we will provide full refunds and investigate the technical problem.</p>

            <h2>Contact Information</h2>
            
            <div className="contact-section">
              <h3>Customer Service</h3>
              <p><strong>Business Hours:</strong> Monday - Friday (9:00 AM - 6:00 PM)</p>
              <p><strong>Address:</strong> FLOOR LG TOWN CENTRAL, LGB-08, BLOCK B, C04 SEC 16B, Greater Noida GHORI, Greater Noida, India</p>
              <p><strong>Email:</strong> Contact us through our website contact form</p>
              <p><strong>Response Time:</strong> We aim to respond to all refund requests within 24 hours during business days</p>
            </div>

            <h2>Policy Updates</h2>
            <p>This refund policy may be updated from time to time to reflect changes in our business practices or legal requirements. Any changes will be posted on this page with an updated effective date. Continued use of our services after such changes constitutes acceptance of the updated policy.</p>

            <div className="important-note">
              <h3>Important Note</h3>
              <p>This policy is designed to be fair to both our customers and our business. We are committed to providing high-quality products and excellent customer service. For the fastest resolution of any issues, please contact us immediately rather than waiting.</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .refund-page {
          min-height: 100vh;
          background-color: #fff8f0;
          padding: 40px 0 80px;
        }

        .content-wrapper {
          max-width: 800px;
          margin: 0 auto;
          background: white;
          padding: 40px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        h1 {
          color: #C2185B;
          text-align: center;
          margin-bottom: 30px;
          font-size: 2.5rem;
        }

        h2 {
          color: #C2185B;
          margin-top: 40px;
          margin-bottom: 20px;
          font-size: 1.8rem;
          border-bottom: 2px solid #C2185B;
          padding-bottom: 10px;
        }

        h3 {
          color: #C2185B;
          margin-top: 30px;
          margin-bottom: 15px;
          font-size: 1.3rem;
        }

        .content p {
          margin-bottom: 15px;
          line-height: 1.6;
          color: #333;
          text-align: justify;
        }

        .content ul {
          margin-bottom: 20px;
          padding-left: 25px;
        }

        .content li {
          margin-bottom: 8px;
          line-height: 1.6;
          color: #333;
        }

        .content strong {
          color: #C2185B;
          font-weight: 600;
        }

        .contact-section {
          background: #f8f9fa;
          padding: 25px;
          border-radius: 10px;
          border-left: 4px solid #C2185B;
          margin: 30px 0;
        }

        .contact-section h3 {
          margin-top: 0;
          color: #C2185B;
        }

        .contact-section p {
          margin-bottom: 10px;
          text-align: left;
        }

        .important-note {
          background: linear-gradient(135deg, #fff0f5, #fce4ec);
          padding: 25px;
          border-radius: 15px;
          border: 2px solid #C2185B;
          margin-top: 40px;
        }

        .important-note h3 {
          margin-top: 0;
          color: #C2185B;
          text-align: center;
        }

        .important-note p {
          text-align: center;
          font-weight: 500;
          color: #333;
        }

        @media (max-width: 768px) {
          .content-wrapper {
            margin: 0 20px;
            padding: 30px 20px;
          }

          h1 {
            font-size: 2rem;
          }

          h2 {
            font-size: 1.5rem;
          }

          h3 {
            font-size: 1.2rem;
          }

          .content p, .content li {
            text-align: left;
          }
        }
      `}</style>
    </div>
  );
};

export default RefundPage; 